import classNames from 'classnames';

import type { LoaderElementProps } from './LoaderElement.types';

export function LoaderElement({ count = 4, heightClassName = 'h-8', className = '' }: LoaderElementProps) {
  return (
    <div className={classNames('flex flex-col gap-y-2', className)}>
      {Array.from({ length: count }).map((_, idx) => (
        <div key={idx} className={classNames('w-full rounded bg-gray-100/80', heightClassName)} />
      ))}
    </div>
  );
}
